import React from "react";
import ReactDOM from "react-dom/client";
import "vite/modulepreload-polyfill";

import CYOModal from "./CYOModal";
import { ModalEvent } from "./eventEnums";

const cyoRoot = document.querySelector("#cyo-root");

if (cyoRoot) {
  ReactDOM.createRoot(cyoRoot).render(
    <React.StrictMode>
      <React.Suspense>
        <CYOModal />
      </React.Suspense>
    </React.StrictMode>,
  );
}

const initCYOTriggers = () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    "button.js-named-enquiry-button",
  );

  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const eventData = {
        enquiryTitle: button.dataset.enquiryTitle,
        enquiryPrice: button.dataset.enquiryPrice,
        enquiryNights: button.dataset.enquiryNights,
      };

      window.postMessage({
        eventType: ModalEvent.OPEN_MODAL,
        event: eventData,
      });
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCYOTriggers);
} else {
  initCYOTriggers();
}
